export default "__VITE_ASSET__D13OViq8__"